import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import TagManager from 'react-gtm-module';
import Router from './Router/Router';
import './App.scss';
import { sentryInit } from '../../SentryConfig';

sentryInit();

if (process.env.GTM_ID?.length && process.env.GTM_ID?.length > 0) {
  const tagManagerArgs = {
    gtmId: process.env.GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);
}

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <Router />
  </StrictMode>
);
